import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.formData.payee_info ? _c('div', [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u56FD\u5BB6/\u5730\u533A"),
      "prop": "payee_info.country_code",
      "label": _vm.t('付款方国家/地区')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择'),
      "show-search": ""
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: _vm.formData.payee_info.country_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "country_code", $$v);
      },
      expression: "formData.payee_info.country_code"
    }
  }, _vm._l(_vm.registerCountryList, function (item) {
    return _c('a-select-option', {
      key: item.country_code,
      attrs: {
        "value": item.country_code
      }
    }, [_vm._v(_vm._s(item.country_name))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u7701/\u5DDE"),
      "prop": "payee_info.province_code",
      "label": _vm.t('付款方省/州')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "placeholder": _vm.t('请选择'),
      "show-pre-tip": _vm.$util.isShowPreTip(_vm.formData.payee_info.country_code),
      "pre-tip-content": _vm.t('请先选择付款方国家/地区')
    },
    model: {
      value: _vm.formData.payee_info.province_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "province_code", $$v);
      },
      expression: "formData.payee_info.province_code"
    }
  }, [_vm._l(_vm.provinceList, function (item) {
    return [_c('a-select-option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])];
  })], 2)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u57CE\u5E02"),
      "prop": "payee_info.city_name",
      "label": _vm.t('付款方城市')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "max-length": 35
    },
    model: {
      value: _vm.formData.payee_info.city_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "city_name", $$v);
      },
      expression: "formData.payee_info.city_name"
    }
  }), _c('common-tips', {
    attrs: {
      "data": [_vm.t('付款方为企业则填写企业注册地址所在城市；付款方为个人则填写个人身份证所在城市。')]
    }
  })], 1), _vm.isShowCaAddress ? [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u8857\u9053\u540D"),
      "prop": "payee_info.street",
      "label": _vm.t('付款方街道名')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "max-length": 70
    },
    model: {
      value: _vm.formData.payee_info.street,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "street", $$v);
      },
      expression: "formData.payee_info.street"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u5EFA\u7B51\u53F7"),
      "prop": "payee_info.building_no",
      "label": _vm.t('付款方建筑号')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "max-length": 16
    },
    model: {
      value: _vm.formData.payee_info.building_no,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "building_no", $$v);
      },
      expression: "formData.payee_info.building_no"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED8\u6B3E\u65B9\u90AE\u7F16"),
      "prop": "payee_info.postal_code",
      "label": _vm.t('付款方邮编')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "max-length": 16
    },
    model: {
      value: _vm.formData.payee_info.postal_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData.payee_info, "postal_code", $$v);
      },
      expression: "formData.payee_info.postal_code"
    }
  })], 1)] : _vm._e()], 2) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };